export enum WIDGET_TRAINING_LIST {
    /**
     * @value Select training courses
     */
    SECTION_TITLE = 'WIDGET_TRAINING_LIST.SECTION_TITLE',
    /**
     * @value Selected training list options
     */
    TRAININGS_LIST_WIDGET_SETTINGS_TITLE = 'WIDGET_TRAINING_LIST.TRAININGS_LIST_WIDGET_SETTINGS_TITLE',
    /**
     * @value No trainings yes
     */
    WRITER_MODE_EMPTY_STATE_TITLE = 'WIDGET_TRAINING_LIST.WRITER_MODE_EMPTY_STATE_TITLE',
}
